// Genera una matriz de letras de tamaño filas x columnas
// Cada fila es una palabra random (sin repetir) y cada celda es una letra en mayúsculas
export function generarMiniaturaRandom(palabras, filas = 3, columnas = 3) {
  if (palabras.length < filas) {
    throw new Error('No hay suficientes palabras para llenar la miniatura sin repeticiones');
  }
  // Mezcla el array y toma tantas palabras como filas
  const palabrasElegidas = [...palabras].sort(() => Math.random() - 0.5).slice(0, filas);
  const matriz = palabrasElegidas.map(palabra => palabra.slice(0, columnas).toUpperCase().split(""));
  return matriz;
} 